import { render, staticRenderFns } from "./PacklistReader.vue?vue&type=template&id=843e2cc8&scoped=true"
import script from "./PacklistReader.vue?vue&type=script&lang=ts"
export * from "./PacklistReader.vue?vue&type=script&lang=ts"
import style0 from "./PacklistReader.vue?vue&type=style&index=0&id=843e2cc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843e2cc8",
  null
  
)

export default component.exports